import { DashboardsViews } from '@/store/dashboards/utils/types'

export const generateSlug = () => (Math.random() + 1).toString(36).substring(7)

export const slugFromName = (name: string) =>
  name
    .toLowerCase()
    .replace(/\s/g, '-')
    .replace(/[^a-z0-9\-]/g, '')

export const getUniqueDashboardName = (
  name: string,
  list: DashboardsViews[] | undefined,
) => {
  if (!list?.length) return name
  const existing = new Set(list.map(item => item.name))
  if (!existing.has(name)) return name
  let i = 1
  while (existing.has(`${name} ${i}`)) i++
  return `${name} ${i}`
}

export const getUniqueDashboardSlug = (
  name: string,
  list: DashboardsViews[] | undefined,
  slugValue?: string,
) => {
  const derived = slugValue || slugFromName(name)
  const duplicate = list?.find(item => item.slug === derived)
  return duplicate ? generateSlug() : derived || generateSlug()
}
